import React from "react";
import { FiArrowRight, FiFileText } from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

import { FALLBACK_NEWS_IMAGE } from "../utils/newsUtils";

export default function NewsCard({ item, onOpen, delay = 0 }) {
  const handleOpen = () => {
    onOpen?.(item);
  };

  return (
    <Reveal delay={delay}>
      <article className="group flex h-full flex-col overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[#1277B9]/50 hover:shadow-xl dark:border-slate-800 dark:bg-slate-950">
        <div className="relative overflow-hidden bg-slate-100 dark:bg-slate-900">
          <img
            src={item.image}
            alt={item.title}
            loading="lazy"
            className="aspect-[16/10] w-full object-cover transition duration-500 group-hover:scale-105"
            onError={(event) => {
              event.currentTarget.src = FALLBACK_NEWS_IMAGE;
            }}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/55 via-slate-950/10 to-transparent" />

          <div className="absolute bottom-4 left-4 right-4 flex flex-wrap items-center gap-2">
            {/* <span className="inline-flex items-center gap-1.5 rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-[#1277B9] shadow-sm backdrop-blur dark:bg-slate-950/90 dark:text-sky-300">
              <FiFileText className="h-3.5 w-3.5" />
              Actualité
            </span> */}

            {/* {item.year && (
              <span className="inline-flex rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-slate-700 shadow-sm backdrop-blur dark:bg-slate-950/90 dark:text-slate-200">
                {item.year}
              </span>
            )} */}
          </div>
        </div>

        <div className="flex flex-1 flex-col p-5">
          {item.dateLabel && (
            <p className="text-[10px] font-extralight tracking-[0.16em] text-slate-600 dark:text-slate-500">
              Publié le {item.dateLabel}
            </p>
          )}

          <h2 className="mt-3 line-clamp-2 text-xl font-bold leading-snug text-slate-950 dark:text-white">
            {item.title || "Sans titre"}
          </h2>

          <p className="mt-4 line-clamp-4 text-sm leading-7 text-slate-600 dark:text-slate-300">
            {item.excerpt || "Aucun contenu renseigné."}
          </p>

          <div className="mt-auto flex flex-wrap gap-2 pt-5">
            <button
              type="button"
              onClick={handleOpen}
              className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-2xl bg-[#1277B9] px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-[#0f659d] focus:outline-none focus:ring-2 focus:ring-[#1277B9]/40 sm:flex-none"
            >
              Lire l’article
              <FiArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </article>
    </Reveal>
  );
}